"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.List = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var storybook_1 = require("@eyecons/storybook");
var List = function (_a) {
    var videos = _a.videos, user = _a.user, channel = _a.channel, simple = _a.simple, preview = _a.preview, download = _a.download, onShare = _a.onShare, onDelete = _a.onDelete, starred = _a.starred, setVideos = _a.setVideos;
    return react_1.default.createElement(storybook_1.Lists.List, { type: 'grid' }, videos.data
        .sortBy('created_at_raw', 'desc')
        .sortBy('starred', 'desc')
        .map(function (video, index) { return react_1.default.createElement(storybook_1.Videos.ListItem, { key: index, user: user, channel: channel, video: video, videos: videos.data, setVideos: setVideos, simple: simple, preview: preview, download: download, onShare: onShare, onDelete: onDelete, starred: starred }); }));
};
exports.List = List;
exports.List.propTypes = {
    /**
     * Current user session
     */
    user: prop_types_1.default.shape({
        id: prop_types_1.default.number.isRequired,
    }),
    /**
     * The Params for the request
     */
    params: prop_types_1.default.object,
    starred: prop_types_1.default.bool,
};
exports.List.defaultProps = {
    starred: false,
};
